import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';

export default function Markdown({ id, markdown, onLoad }) {
	const axiosAbortController = useMemo(() => new AbortController(), []);
	const markdownLoaded = useRef(false);
	const [markdownStr, setMarkdownStr] = useState('Loading...');
	const imgUrlToBase64 = useCallback(url => new Promise(resolve => {
			var xhr = new XMLHttpRequest();
			xhr.onload = () => {
					var reader = new FileReader();
					reader.onloadend = () => resolve(reader.result);
					reader.readAsDataURL(xhr.response);
			};
			xhr.open('GET', url);
			xhr.responseType = 'blob';
			xhr.send();
	}), []);
	const imgRelativeToAbsolute = useCallback(markdownStr => markdownStr.replaceAll(/!\[([^\]]*)\]\(((?!http)[^)\s]+)(?:\s['"`][^'"`]*['"`])?\)/gi, `![$1](${process.env.PUBLIC_URL}/manual$2)`), []);
	const imgAbsoluteToBase64 = useCallback(async markdownStr => {
		let newMarkdownStr = imgRelativeToAbsolute(markdownStr);
		const matches = newMarkdownStr.matchAll(/!\[[^\]]*\]\(([^)\s]+)(?:\s['"`][^'"`]*['"`])?\)/gi); // match all image URLs
		for(let match of matches) {
			if(!match?.[1]) { continue } // match[1] -> image url
			const imageUrl = match[1];
			const base64 = await imgUrlToBase64(imageUrl);
			newMarkdownStr = newMarkdownStr.replaceAll(imageUrl, base64);
		}
		return newMarkdownStr
	}, [ imgRelativeToAbsolute, imgUrlToBase64 ]);
	useEffect(() => {
		if(markdownLoaded.current) { return }
		axios.get(markdown, { signal: axiosAbortController.signal })
			.then(res => res.data)
			.then(markdownStr => imgAbsoluteToBase64(markdownStr))
			.then(markdownStr => {
				markdownLoaded.current = true;
				setMarkdownStr(markdownStr);
				onLoad(markdown);
			});
	}, [markdown, imgAbsoluteToBase64, onLoad, axiosAbortController]);
	useEffect(() => {
		return () => axiosAbortController.abort();
	}, [ axiosAbortController ]);
	return (
		<div id={id} className="markdown-wrapper">
			<ReactMarkdown children={markdownStr} />
		</div>
	);
}